import React, { Fragment, useContext, useState } from 'react';
import styles from './MainAd.module.scss';
import { SFButton, SFFade, SFPaper, SFText } from 'sfui';
import {
  UserContext,
  isPlanAnalytics,
  isRoleManager,
  isRoleOwner,
  useSubscription
} from 'ui-smartforce-settings';
import { useHistory } from 'react-router-dom';
import { getCurrentAppByHostname } from '../../Helpers';

function isOwnerOrManager(roleId?: string) {
  return isRoleOwner(roleId) || isRoleManager(roleId);
}

export const MainAd = (): React.ReactElement<{}> => {
  const history = useHistory();
  const { user } = useContext(UserContext);
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const subscription = useSubscription(getCurrentAppByHostname());

  const onUpgrade = () => {
    setIsOpen(false);

    if (isRoleOwner(user?.role.id)) {
      history.push('/app/plan-upgrade');
    } else if (isRoleManager(user?.role.id)) {
      history.push('/app/analytics');
    }
  };

  return (
    <Fragment>
      {history.location.pathname !== '/app/onboarding' &&
        isOwnerOrManager(user?.role.id) &&
        subscription?.product === 'cc' &&
        !isPlanAnalytics(subscription?.plan) && (
          <SFFade in={isOpen} mountOnEnter unmountOnExit>
            <SFPaper className={styles.mainAd}>
              <div className={styles.image}></div>

              <div className={styles.description}>
                <SFText type="component-title">
                  Comprehensive, Insightful, Actionable Data
                </SFText>

                <div className={styles.buttons}>
                  <SFButton
                    sfColor="grey"
                    variant="text"
                    onClick={() => setIsOpen(false)}
                  >
                    Close
                  </SFButton>

                  <SFButton onClick={onUpgrade}>Upgrade Now</SFButton>
                </div>
              </div>
            </SFPaper>
          </SFFade>
        )}
    </Fragment>
  );
};
